import { Routes } from '@angular/router';

import { AppGuard } from '../../app/guard/app/app.guard';
import { AuthGuard } from '../../app/guard/auth/auth.guard';

export const notaFacilRoutes: Routes = [
  {
    path: 'nota-facil',
    title: 'NotaFácil | ITC Digital',
    loadComponent: () =>
      import('./home/nota-facil.component').then(m => m.NotaFacilComponent),
    canActivate: [AuthGuard, AppGuard],
    data: { appId: 7 },
    children: [
      {
        path: '',
        title: 'NotaFácil | ITC Digital',
        loadComponent: () =>
          import('./components/nota-dashboard/nota-dashboard.component').then(m => m.NotaDashboardComponent),
        canActivate: [AuthGuard, AppGuard],
        data: { appId: 7 }
      },
      {
        path: 'notas',
        title: 'Notas | NotaFácil',
        loadComponent: () =>
          import('./components/nfe/nfe.component').then(m => m.NfeComponent),
        canActivate: [AuthGuard, AppGuard],
        data: { appId: 7 }
      },
      {
        path: 'eventos',
        title: 'Eventos | NotaFácil',
        loadComponent: () =>
          import('./components/eventos/eventos.component').then(m => m.EventosComponent),
        canActivate: [AuthGuard, AppGuard],
        data: { appId: 7 }
      },
      {
        path: 'detalhes-nota/:id',
        title: 'Detalhes da nota | NotaFácil',
        loadComponent: () =>
          import('./components/nfe-details/nfe-details.component').then(m => m.NfeDetailsComponent),
        canActivate: [AuthGuard, AppGuard],
        data: { appId: 7 }
      },
      {
        path: 'arquivos',
        title: 'Arquivos | NotaFácil',
        loadComponent: () =>
          import('./components/files/files.component').then(m => m.FilesComponent),
        canActivate: [AuthGuard, AppGuard],
        data: { appId: 7 }
      }
    ]
  }
];